import { FC } from 'react';
import { Flex, FlexProps, Text, theme } from '@chakra-ui/react';
import Lemon from 'ui/components/Icons/Lemon';
const getRandomReaction = () => {
  const reactions = ['Drats', 'Darn', 'Bummer', 'Dag-nab-it', 'Oof'];
  return reactions[Math.floor(Math.random() * reactions.length)];
};
export const CbChestsPrizeLemon: FC<FlexProps> = ({
  ...props
}) => {
  return <Flex alignItems="center" {...props} data-sentry-element="Flex" data-sentry-component="CbChestsPrizeLemon" data-sentry-source-file="CbChestsPrizeLemon.tsx">
      <Lemon marginRight={[1, 2]} height="60px" position="relative" width={['50px', '64px']} zIndex={theme.zIndices.docked} data-sentry-element="Lemon" data-sentry-source-file="CbChestsPrizeLemon.tsx" />
      <Text position="relative" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="CbChestsPrizeLemon.tsx">
        {`${getRandomReaction()}! A lemon.`}
      </Text>
    </Flex>;
};